import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Zap, Activity, LineChart, Apple, ArrowRight } from "lucide-react";

export function GoalSelector() {
  const { t } = useTranslation();

  const GOALS = [
    {
      icon: Zap,
      title: t("goalSelector.goal1"),
      to: "/services/football-training",
      color: "var(--svc-football)",
    },
    {
      icon: Activity,
      title: t("goalSelector.goal2"),
      to: "/categories/athletic-training",
      color: "var(--svc-athletic)",
    },
    {
      icon: LineChart,
      title: t("goalSelector.goal3"),
      to: "/services/gym-training",
      color: "var(--svc-gym)",
    },
    {
      icon: Apple,
      title: t("goalSelector.goal4"),
      to: "/services/nutrition",
      color: "var(--svc-nutrition)",
    },
  ] as const;

  return (
    <section aria-labelledby="goal-selector-heading" className="py-16 px-4 bg-background">
      <div className="container mx-auto max-w-6xl">
        <h2
          id="goal-selector-heading"
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3 text-foreground [hyphens:none] [overflow-wrap:break-word]"
        >
          {t("goalSelector.heading")}
        </h2>
        <p className="text-center text-base text-muted-foreground mb-12 max-w-2xl mx-auto break-words">
          {t("goalSelector.subheading")}
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-5">
          {GOALS.map(({ icon: Icon, title, to, color }) => (
            <Link
              key={to}
              to={to}
              className="accent-card-link group relative block pt-5 focus-visible:outline-none"
              style={{ ["--goal" as string]: color, ["--card-accent" as string]: color }}
            >
              {/* colored folder shell */}
              <span
                aria-hidden="true"
                className="absolute inset-x-0 top-0 bottom-0 translate-x-1.5 translate-y-1.5 rounded-2xl transition-transform duration-300 group-hover:translate-x-2 group-hover:translate-y-2"
                style={{ backgroundColor: "hsl(var(--goal))" }}
              />
              {/* folder tab */}
              <span
                aria-hidden="true"
                className="absolute left-3 top-0 h-8 w-2/5 rounded-t-xl"
                style={{ backgroundColor: "hsl(var(--goal))" }}
              />

              <div
                className="accent-card relative flex h-full min-h-[340px] flex-col items-center rounded-2xl border border-white/5 p-6 text-center"
                style={{
                  backgroundColor: "hsl(var(--goal-surface))",
                }}
              >
                <Icon
                  className="mt-2 mb-6 h-14 w-14 stroke-[1.25] text-foreground transition-transform duration-300 group-hover:scale-110"
                  aria-hidden="true"
                />

                <p className="accent-title mb-auto text-lg sm:text-xl font-bold leading-tight text-foreground text-balance [hyphens:none] [overflow-wrap:break-word] [word-break:normal]">
                  {title}
                </p>

                <span
                  className="accent-cta mt-6 inline-flex w-full items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-bold"
                  style={{
                    backgroundColor: "hsl(var(--goal))",
                    color: "hsl(var(--goal-foreground))",
                  }}
                >
                  {t("goalSelector.cta")}
                  <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </span>
              </div>

            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}

export default GoalSelector;
